import { useQuery } from '@tanstack/react-query';
import { axios } from './axios';
import { ExtractFnReturnType, QueryConfig } from "./queryConfig";


interface IFacilityConfig {
  project_id: string | undefined
  slug: string
}

type ResponseData = {
  config: {
    [key: string]: any  
  }

}

export const getFacilityConfig = ({project_id, slug}: IFacilityConfig): Promise<ResponseData> => {
  return axios.get(`/oe/config/project/${project_id}/${slug}/facility-config`).then(res => res.data as ResponseData)
}

type QueryFnType = typeof getFacilityConfig;
interface IuseFacilityConfigData extends IFacilityConfig {
  config: QueryConfig<QueryFnType>
}

export const useFacilityConfig = ({ project_id, slug, config }: IuseFacilityConfigData) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['facilityConfig', project_id, slug],
    queryFn: () => getFacilityConfig({ project_id, slug }),
    enabled: !!project_id && !!slug,
    ...config

    })
}